import { Field } from 'formik';
import formikMetaToState from '../../helpers/formikMetaToState';
import { Datepicker, DatepickerProps } from '../Datepicker';

export const FormikDatepicker = (props: DatepickerProps & { name: string }) => {
  const { name } = props;
  return (
    <Field name={name}>
      {({ field, meta, form }: any) => {
        const { error, state } = formikMetaToState(meta);
        return (
          <Datepicker
            {...field}
            {...props}
            error={error}
            state={state}
            onChange={(v) => {
              form.setFieldValue(field.name, v, true /*validate*/);
            }}
          />
        );
      }}
    </Field>
  );
};
